<template>
  <BreadCrumb :crumbs="crumbs" />
  <CreateOrEditCampaignForm />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";

import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import CreateOrEditCampaignForm from "@/modules/Offers/components/CreateOrEditCampaignForm.vue";
import links from "@/router/links";

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();

const redirectToCampaignList = () => {
  router.push({ name: links.offersAndStore.tabs.offerCampaigns.campaignList });
};

const crumbs = computed(() => [
  { label: "Offer campaigns", action: redirectToCampaignList },
  { label: "New campaign" },
]);
</script>
